import React from 'react';
import { Countdown } from './Countdown';
import { OfferSelector } from './OfferSelector';
export const Pricing = () => {
  return <section id="pricing" className="py-16 bg-cream" data-id="element-221">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-222">
        {/* Offer Header */}
        <div className="text-center mb-8" data-id="element-223">
          <div className="inline-flex items-center gap-2 bg-red-100 text-red-700 font-bold px-4 py-1.5 rounded-full text-sm mb-5 animate-pulse" data-id="element-224">
            <span className="w-2 h-2 rounded-full bg-red-600" data-id="element-225"></span> Oferta en
            vivo
          </div>

          <h2 className="text-2xl md:text-3xl font-heading font-bold text-gray-900 mb-2" data-id="element-226">
            Elegí tu Pack Docente 2026
          </h2>
          <p className="text-base text-gray-600 mb-6" data-id="element-227">
            Ambas opciones incluyen los 6 bonos de ficheros imprimibles
            completos
          </p>

          <div className="bg-white p-5 rounded-2xl shadow-sm border border-brand-orange/20 max-w-xl mx-auto mb-8" data-id="element-228">
            <p className="text-xs font-bold text-gray-500 uppercase tracking-wider mb-2" data-id="element-229">
              LANZAMIENTO TERMINA EN
            </p>
            <Countdown data-id="element-230" />
            <p className="text-sm text-brand-orange font-medium mt-3" data-id="element-231">
              +$8.000 DESPUÉS — Y no vuelve a bajar
            </p>

            <div className="mt-4" data-id="element-232">
              <div className="flex justify-between text-xs font-bold text-gray-500 mb-1" data-id="element-233">
                <span data-id="element-234">Cupos restantes</span>
                <span className="text-brand-green" data-id="element-235">68% TOMADOS</span>
              </div>
              <div className="w-full bg-gray-100 rounded-full h-2.5" data-id="element-236">
                <div className="bg-brand-green h-2.5 rounded-full" style={{
                width: '68%'
              }} data-id="element-237"></div>
              </div>
            </div>
          </div>
        </div>

        <OfferSelector data-id="element-238" />
      </div>
    </section>;
};